// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2z5AO","inner":"Footer_inner__3kWFc"};